/** @jsxImportSource @emotion/react */

import SupplierImg from "assets/desktop/images/footer/supplier.png";

import { SupplierBlockStyle } from "./index.style";

const SupplierBlock = () => {
  return (
    <div css={SupplierBlockStyle.self}>
      <h4 css={SupplierBlockStyle.title}>Nhà cung cấp</h4>
      <img src={SupplierImg} alt="" />
    </div>
  );
};

export default SupplierBlock;
